import {
  type TermLifeStepParams,
  employmentStatusSchema,
} from '@flows/configs/de/termLife/steps/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

export const employmentStatus = (params: TermLifeStepParams) => {
  const schema = employmentStatusSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_termLife:steps.employment_status.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_term_life_insurance_de.shape.configuration_parameters.shape.employment_status.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_termLife:steps.employment_status.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('employment_status'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'yearly_income',
    subFlow: SubFlow.TermLife,
  } as const satisfies AnyStepConfiguration
}
